export const linkedAccountsQueryKeys = {
  all: ['linked-accounts'],
} as const;
